<div class="container-fluid pt-5">
  <div class="row">
    <div class="col-lg-2 col-xl-3">

    </div>
    <div class="col-12 col-lg-8 col-xl-6">

      <h3>Registration</h3>
      <p>
        Wenn Sie Eltern sind und noch keinen Account besitzen, können Sie über dieses Formular einen erstellen:
      </p>
      <div class="container-fluid">
        <div class=" form-group my-4 my-lg-2" *ngFor="let line of fields1">
          <app-input [(val)]="nutzer[line.key]" [name]="line.label" [tooltip]="line.label" [required]="line.pflichtfeld"
                     [placeholder]="" [type]="line.type"></app-input>
        </div>
        <div class="w-100">
          <app-password-check [password]="nutzer.passwort"
                              (passwordValid)="passwordValid = $event"></app-password-check>
        </div>
        <div class=" form-group my-4 my-lg-2" *ngFor="let line of fields2">
          <app-input [(val)]="nutzer[line.key]" [name]="line.label" [tooltip]="line.label" [required]="line.pflichtfeld"
                     [placeholder]="" [type]="line.type"></app-input>
        </div>
        <div class="w-100">
          Bankdaten, damit Rücküberweisungen bei stornierten Anmeldungen abgewickelt werden können.
        </div>
        <div class=" form-group my-4 my-lg-2" *ngFor="let line of fields3">
          <app-input [(val)]="nutzer[line.key]" [name]="line.label" [tooltip]="line.label" [required]="line.pflichtfeld"
                     [placeholder]="" [type]="line.type"></app-input>
        </div>
        <div>
          <input type="checkbox" class="largeCheckbox" [(ngModel)]="acceptAGBs"> Ich bin mit den <a routerLink="/bedingungen" target="_blank">Bedingungen</a> einverstanden.
        </div>
      </div>
      <button class="btn pcButton my-3 ml-3" (click)="send()">Zugang anfragen</button>
    </div>

  </div>
</div>

